import { useForm } from 'react-hook-form'
import { useSubscribeToTalentNewsletterMutation } from '@platform/data-access'
import { EMAIL_VALIDATION, REQUIRED_FIELD } from '@platform/utils'
import { toast } from '@platform/ui-kit'

import WebsiteInput from '../website-kit/input'

import styles from './index.module.scss'

type FormDataType = {
  email: string
}

type NewsletterFormProps = {
  className?: string
}
export const NewsletterForm = ({ className }: NewsletterFormProps) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm<FormDataType>({ mode: 'onSubmit' })

  const { mutate, isLoading } = useSubscribeToTalentNewsletterMutation({
    onSuccess: () => {
      reset()
      toast({ title: 'You successfully joined our newsletter!' })
    },
  })

  const actionButton = {
    label: 'Subscribe',
    isLoading,
  }

  const onSubmit = handleSubmit(formData => {
    mutate(formData)

    return
  })

  return (
    <form className={className} onSubmit={onSubmit}>
      <WebsiteInput
        placeholder="Your email"
        label="Your email"
        id="newsletterEmailInput"
        actionButton={actionButton}
        className={styles['input']}
        {...register('email', {
          required: REQUIRED_FIELD,
          validate: EMAIL_VALIDATION,
        })}
        error={errors.email?.message}
      />
    </form>
  )
}

export default NewsletterForm
